<template>
  <div class="active">
    <div class="selector">
      <div class="date">
        <img class="calendar" src="@/assets/image/home/content_icon_calendar2x.png" alt="" />
        <span @click="showCalendar = true">{{ date }}</span>
        <img class="dropdown" src="@/assets/image/home/content_icon_dropdown2x.png" alt="" />
      </div>
      <ul>
        <li
          @click="handleChangeActive(index)"
          :class="{active: active === index}"
          v-for="(item, index) in actList"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="main-content">
      <div v-if="isToday">
        <div class="sub-title">
          <span></span>
          今天
        </div>
        <div v-if="today.length" class="container">
          <activeBox :active="item" v-for="item in today" :key="item.id"></activeBox>
        </div>
        <van-empty v-else description="暂无活动"></van-empty>
        <div class="sub-title">
          <span></span>
          明天
        </div>
        <div v-if="tomorrow.length" class="container">
          <activeBox :active="item" v-for="item in tomorrow" :key="item.id"></activeBox>
        </div>
        <van-empty v-else description="暂无活动"></van-empty>
        <div class="sub-title">
          <span></span>
          后天
        </div>
        <div v-if="aftertomorrow.length" class="container">
          <activeBox :active="item" v-for="item in aftertomorrow" :key="item.id"></activeBox>
        </div>
        <van-empty v-else description="暂无活动"></van-empty>
      </div>
      <template v-else>
        <div v-if="today.length" class="container">
          <activeBox :active="item" v-for="item in today" :key="item.id"></activeBox>
        </div>
        <van-empty v-else description="暂无活动"></van-empty>
      </template>
    </div>
    <van-calendar v-model="showCalendar" :min-date="minDate" @confirm="onConfirm" />
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getEventList} from '@/api'
import {formatDate} from '@/filters'
export default {
  components: {
    activeBox: () => import('./activeBox')
  },
  data() {
    return {
      active: 0,
      actList: ['全部', '录播预约', '同步课堂', '视频会议', '直播教研', '互动教研', ' 直播教学', '直播'],
      date: '',
      showCalendar: false,
      today: [],
      tomorrow: [],
      aftertomorrow: [],
      isToday: true,
      minDate: new Date(2000, 0, 1)
    }
  },
  created() {
    this.date = formatDate(new Date(), 'yyyy-MM-dd')
    this.init()
  },
  methods: {
    init() {
      const params = {
        date: this.isToday ? '' : this.date,
        order: this.active === 0 ? '' : this.active
      }
      getEventList(params).then(res => {
        this.today = res.data.today
        this.tomorrow = res.data.tomorrow
        this.aftertomorrow = res.data.aftertomorrow
      })
    },
    handleChangeActive(index) {
      if (this.active === index) return false
      this.active = index
      this.init()
    },
    onConfirm(date) {
      this.showCalendar = false
      this.date = formatDate(+date, 'yyyy-MM-dd')
      if (this.date === formatDate(+new Date(), 'yyyy-MM-dd')) {
        this.isToday = true
      } else {
        this.isToday = false
      }
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
}
.selector {
  padding: 10px 16px;
  background: #fff;
  .date {
    display: flex;
    align-items: center;
    padding-top: 10px;
    span {
      font-size: 16px;
      padding-left: 7px;
      font-weight: 700;
    }
    .calendar {
      width: 16px;
    }
    .dropdown {
      width: 11px;
      margin-left: 4px;
    }
  }
  ul {
    overflow-x: scroll;
    white-space: nowrap;
    padding: 16px 0 0 0;
    li {
      font-size: 14px;
      display: inline-block;
      padding-bottom: 6px;
      color: rgba(48, 49, 51, 1);
    }
    li + li {
      margin-left: 16px;
    }
    li.active {
      position: relative;
      color: #4465f3;
      font-weight: 700;
    }
    li.active::after {
      content: '';
      position: absolute;
      width: 4px;
      height: 4px;
      background: #4465f3;
      border-radius: 2px;
      left: 50%;
      bottom: 0;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.main-content {
  padding: 28px 16px;
}

// =======
.sub-title {
  position: relative;
  color: #303133;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: 700;
  margin-bottom: 20px;
  span {
    display: inline-block;
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background: #4465f3;
    margin-right: 6px;
  }
}
</style>
<style lang="scss">
.active .van-calendar__selected-day {
  background: #4465f3;
}
.active .van-button--danger {
  background: #4465f3;
  border-color: #4465f3;
}
</style>
